module.exports = __webpack_public_path__ + "img/c5201704-1.f31cd797.jpg";